import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface NavLinkProps {
  to: string;
  status?: boolean;
  children: React.ReactNode;
  isActive?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

const StyledNavLink = styled(Link)<{ status?: boolean; isActive?: boolean }>`
  width: 165px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({status = true}) => status ? "pointer" : "not-allowed"};
  text-decoration: none;
  color: ${({isActive}) => isActive ? "#2282e9" : "#797979"};
  // pointer-events: ${({status = true}) => status ? "auto" : "none"};
  opacity: ${({status = true}) => status ? 1 : 0.5};
  border-bottom: ${({isActive}) => isActive ? "2px solid #2282E9" : "none"};
  
  &:hover {
    opacity: ${({status = true, isActive}) => isActive ? 1 : status ? 0.8 : 0.5};
  }
`;

const CustomNavLink: React.FC<NavLinkProps> = ({ to, status = true, children, isActive = false, onClick }) => {
  // 링크 클릭 핸들러 함수
  const handleNavLinkClick = (e: React.MouseEvent) => {
    if (!status) {
      e.preventDefault();
    }
    // 외부에서 전달받은 onClick 핸들러가 있으면 실행
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <StyledNavLink 
      to={to} 
      status={status} 
      isActive={isActive}
      onClick={handleNavLinkClick}
    >
      {children}
    </StyledNavLink>
  );
};

export default CustomNavLink;